import { Component, OnInit, Renderer2, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { environment } from '../environments/environment';
import { GridConfig } from '@Mobilesentrix/ms-design-system';
import { CommonService } from './shared/services/common';
import { UserInfoService } from './core/services/user-info/user-info.service';
import { readFromStorage, removeFromStorage } from './shared/utils/storage.utils';
import { ConfigListingRestApiService } from './shared/services/config-listing-rest-api.service';
import { IUserInfo } from './core/models/user-info.model';
import { identityFromUser, readStoredUser } from './core/auth/auth-identity';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnInit {
  private readonly renderer = inject(Renderer2);
  private readonly userInfoService = inject(UserInfoService);
  private readonly configListingRestApi = inject(ConfigListingRestApiService);
  gridConfig = inject(GridConfig);
  commonService = inject(CommonService);
  constructor() {
    ['dateformat', 'currencySymbol', 'currencyFormat'].forEach((key) => {
      const val = readFromStorage(key);
      if (val === null) return;
      try {
        JSON.parse(val);
      } catch {
        removeFromStorage(key)
      }
    });

    let userInfo: any = readStoredUser()?.['business_id'];
    const userDateFormat = userInfo?.['date_format'];
    const currencySymbol = userInfo?.['currency_symbol'];
    const currencyFormat = userInfo?.['currency_format'];
    const timeZone = userInfo?.['time_zone'];
    this.gridConfig.dateFormat = userDateFormat;
    this.gridConfig.currencySymbol = currencySymbol;
    this.gridConfig.timeZone = timeZone;
    this.gridConfig.currencyFormat = currencyFormat
  }

  ngOnInit(): void {
    this.loadGoogleMaps();
    this.listenForSsoLogout();
  }

  private listenForSsoLogout(): void {
    window.addEventListener('sso:user-logged-out', (event: any) => {
      // Drop the previous user's identity so a new login in the same tab cannot
      // inherit stale details (header showing the wrong / prior user).
      this.userInfoService.clear();
      removeFromStorage('user');
      removeFromStorage('x-userinfo-hash');
      this.configListingRestApi.clearTempPresets().subscribe();
    });
  }

  private loadGoogleMaps(): void {
    if (document.getElementById('google-maps-script')) return;
    const key = environment?.googleMapsApiKey ?? '';
    const script = this.renderer.createElement('script');
    script.id = 'google-maps-script';
    script.src = `https://maps.googleapis.com/maps/api/js?key=${key}&libraries=places&loading=async&region=US&language=en`;
    script.async = true;
    script.defer = true;
    this.renderer.appendChild(document.head, script);
  }
}


